import { memo, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { URLPaths } from 'models/enums';
import MoreOptionsDropdown from 'domains/core/components/MoreOptionsDropdown';
import { AccessCentreUser } from 'domains/accessCentre/types';

export type UsersTableOptionsCellProps = {
    user: AccessCentreUser;
};

/**
 * Memoized cell that renders the more options dropdown for a user row (e.g. Change Role).
 */
const UsersTableOptionsCell = ({ user }: UsersTableOptionsCellProps) => {
    const history = useHistory();

    const handleChangeRole = useCallback(() => {
        history.push(`${URLPaths.SETTINGS_USERS}/${user.id}`);
    }, [history, user.id]);

    const menuItems = useMemo(
        () => [
            {
                name: 'Change Role',
                onClick: handleChangeRole,
                testId: `access-center-user-change-role-${user.id}`,
            },
        ],
        [handleChangeRole, user.id]
    );

    return <MoreOptionsDropdown buttonTestId={`access-center-user-options-${user.id}`} menuItems={menuItems} />;
};

export default memo(UsersTableOptionsCell);
